$dependencyManager.addDependenciesCallback(['swiper', 'hls', 'plyr'], () => {
  class HoverVideoSlider {
    constructor(container) {
      this.container = jQuery(container);
      this.slider = this.container.find('> .mad-slider');
      this.sliderId = this.container.data('slider-id');
      this.nextSlideSpeed = this.container.data('speed') || 1000;
      this.loopSlides = this.container.data('loop') || false;
      this.swiper = null;
      this.activeVideo = null;
      this.initSlider();
      //this.initObserver();
      this.initScrollFeature();
      this.initContainerLeaveHandler();
    }

    initContainerLeaveHandler() {
      this.container.on('mouseleave', () => {
        this.pauseAllVideos();
      });
    }

    pauseAllVideos() {
      this.container.find('.mad-hover-video__video').each((index, video) => {
        try {
          const $video = jQuery(video);
          const videoSrc = $video.data('src');
          if (videoSrc) {
            this.pauseVideo($video, videoSrc);
          }
        } catch (error) {
          console.error('Error pausing video:', error);
        }
      });
    }

    initSlider() {
      this.swiper = new Swiper(`.mad-slider__container--hover-video[data-slider-id="${this.sliderId}"] .mad-slider__slides-container`, {
        direction: 'horizontal',
        loop: this.loopSlides,
        speed: this.nextSlideSpeed,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        spaceBetween: 10,
        updateOnWindowResize: true,
        freeMode: true,
        shortSwipes: false,
        longSwipes: false,
      });
  
      this.container.css('opacity', '1');
  
      // Add hover effect for non-touch devices
      this.container.find('.mad-slider__slide').hover(
        (event) => {
          const $video = jQuery(event.currentTarget).find('.mad-hover-video__video');
          const videoSrc = $video.data('src');
          if (!videoSrc) return;
          this.pauseFirstVideo();
          this.pauseAllVideos();
          this.playVideo($video, videoSrc);
          this.activeVideo = $video;
        },
        (event) => {
          const $video = jQuery(event.currentTarget).find('.mad-hover-video__video');
          const videoSrc = $video.data('src');
          if (!videoSrc) return;
          this.pauseVideo($video, videoSrc);
          this.activeVideo = null;
        }
      );
  
      /*
      // For mobile devices: on first tap, play the video; on second tap, follow the link.
      if (window.matchMedia("(pointer: coarse)").matches) {
        this.container.find('.mad-slider__slide').on('click', (event) => {
          const $slide = jQuery(event.currentTarget);
          const $video = $slide.find('.mad-hover-video__video');
          const videoSrc = $video.data('src');
          if (!videoSrc) return;
          // Check if video is already playing (tracked via data attribute)
          if (!$video.data('isPlaying')) {
            // First tap: play video and prevent link navigation.
            event.preventDefault();
            this.pauseFirstVideo();
            this.playVideo($video, videoSrc);
            $video.data('isPlaying', true);
          } else {
            // Second tap: navigate to the link.
            const $link = $slide.find('.mad-hover-video__link');
            if ($link.length && $link.attr('href')) {
              const href = $link.attr('href');
              if (href.indexOf('#') !== -1) {
                const hash = href.slice(href.indexOf('#'));
                const $target = jQuery(hash);
                if ($target.length) {
                  event.preventDefault();
                  jQuery('html, body').animate({ scrollTop: $target.offset().top }, 600);
                  return;
                }
              }
              window.location.href = href;
            }
          }
        });
        
        // New touch event handlers for mobile
        this.container.find('.mad-slider__slide')
          .on('touchstart', (event) => {
            const $video = jQuery(event.currentTarget).find('.mad-hover-video__video');
            const videoSrc = $video.data('src');
            if (!videoSrc) return;
            event.preventDefault();
            this.pauseFirstVideo();
            this.playVideo($video, videoSrc);
          })
          .on('touchend', (event) => {
            const $video = jQuery(event.currentTarget).find('.mad-hover-video__video');
            const videoSrc = $video.data('src');
            if (!videoSrc) return;
            this.pauseVideo($video, videoSrc);
          });
      }*/

      // For mobile devices: hold to play video; quick tap to navigate to link.
      if (window.matchMedia("(pointer: coarse)").matches) {
        const TOUCH_HOLD_DURATION = 200;
        this.container.find('.mad-slider__slide')
          .on('touchstart', (event) => {
            const $slide = jQuery(event.currentTarget);
            const $video = $slide.find('.mad-hover-video__video');
            const videoSrc = $video.data('src');
            if (!videoSrc) return;
            event.preventDefault();
            
            $slide.data('touchTimer', setTimeout(() => {
              this.pauseFirstVideo();
              this.playVideo($video, videoSrc);
              $video.data('isPlaying', true);
            }, TOUCH_HOLD_DURATION));
          })
          .on('touchend', (event) => {
            const $slide = jQuery(event.currentTarget);
            const $video = $slide.find('.mad-hover-video__video');
            const videoSrc = $video.data('src');
            if (!videoSrc) return;
            
            // Clear the timer if touchend happens before 200ms.
            const touchTimer = $slide.data('touchTimer');
            if (touchTimer) {
              clearTimeout(touchTimer);
              $slide.removeData('touchTimer');
            }
            
            // If video was played (held), then pause it; otherwise, navigate.
            if ($video.data('isPlaying')) {
              this.pauseVideo($video, videoSrc);
              $video.data('isPlaying', false);
            } else {
              const $link = $slide.find('.mad-hover-video__link');
              if ($link.length && $link.attr('href')) {
                const href = $link.attr('href');
                if (href.indexOf('#') !== -1) {
                  const hash = href.slice(href.indexOf('#'));
                  const $target = jQuery(hash);
                  if ($target.length) {
                    event.preventDefault();
                    jQuery('html, body').animate({ scrollTop: $target.offset().top }, 600);
                    return;
                  }
                }
                window.location.href = href;
              }
            }
        });
      }
    }

    playVideo($video, videoSrc) {
      $video.prop('muted', true);
      $video.attr('muted', 'muted');
      this.pauseAllVideos();
      $video[0].volume = 0;
      const startTime = parseInt($video.data('start-time')) || 0;

      if (videoSrc.endsWith('.mp4')) {
        if ($video.attr('src') !== videoSrc) {
          $video.attr('src', videoSrc);
        }
        $video[0].play().then(() => {
          if (startTime > 0) {
            $video[0].currentTime = startTime;
          }
        }).catch(() => {});
      } else if (videoSrc.endsWith('.m3u8')) {
        if (!$video.data('player')) {
          const player = new Plyr($video[0], {
            iconUrl: window.madPlyrIconUrl,
            controls: [],
            muted: true,
            autoplay: false,
            loop: { active: true },
            fullscreen: { enabled: false },
            playsinline: true,
            storage: { enabled: false }
          });
          $video.data('player', player);
          player.volume = 0;

          if (Hls.isSupported()) {
            const hls = new Hls({ startLevel: 2,                    // Start from level 2 (720p)
                                  maxBufferLength: 5,               // Buffer up to 5 seconds
                                  maxMaxBufferLength: 10,           // Maximum buffer can go up to 10 seconds
                                  maxBufferSize: 5 * 1000 * 1000,   // Max buffer size in bytes (5MB)
                                  maxBufferHole: 0.5,               // Allow small buffer gaps of 0.5s
                                  lowLatencyMode: true,             // Enable low-latency streaming for faster start
                                  startPosition: startTime,
             });
            hls.loadSource(videoSrc);
            hls.attachMedia($video[0]);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
              player.play().then(() => {
              }).catch(() => {});
            });
            $video.data('hls', hls);
          } else if ($video[0].canPlayType('application/vnd.apple.mpegurl')) {
            $video[0].src = videoSrc;
            $video.on('canplay', () => {
              $video[0].play().then(() => {
                if (startTime > 0) {
                  $video[0].currentTime = startTime;
                }
              }).catch(() => {});
            });
          }
        } else {
          const player = $video.data('player');
          player.play().catch(() => {});
        }
      }
    }

    pauseVideo($video, videoSrc) {
      $video.data('isPlaying', false);
      
      if (videoSrc.endsWith('.mp4')) {
        $video[0].pause();
      } else if (videoSrc.endsWith('.m3u8')) {
        const player = $video.data('player');
        if (player) {
          player.pause();
        }
      }
    }

    playFirstVideo() {
      const $firstSlide = this.container.find('.mad-slider__slide').first();
      if ($firstSlide.length) {
        const $video = $firstSlide.find('.mad-hover-video__video');
        const videoSrc = $video.data('src');
        if (videoSrc) {
          this.playVideo($video, videoSrc);
        }
      }
    }

    pauseFirstVideo() {
      const $firstSlide = this.container.find('.mad-slider__slide').first();
      if ($firstSlide.length) {
        const $video = $firstSlide.find('.mad-hover-video__video');
        const videoSrc = $video.data('src');
        if (videoSrc) {
          this.pauseVideo($video, videoSrc);
        }
      }
    }

    initObserver() {
      // Use IntersectionObserver to play the first video when slider is in view
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playFirstVideo();
            this.observer.disconnect(); // Disconnect observer when video is played
          } else {
            this.pauseFirstVideo();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(this.container[0]);
      this.observer = observer;
    }

    // Scroll to the target when clicking on a link instead of reloading the Page on Desktop
    initScrollFeature(){
      if (!window.matchMedia("(pointer: coarse)").matches) {
        jQuery(document).on('click', '.mad-hover-video__link', function(e) {
          const href = jQuery(this).attr('href');
          if (href.indexOf('#') !== -1) {
            const hash = href.slice(href.indexOf('#'));
            const $target = jQuery(hash);
            if ($target.length) {
              e.preventDefault();
              jQuery('html, body').animate({ scrollTop: $target.offset().top }, 600);
            }
          }
        });
      }
    }
  }

  // Initialisiere HoverVideoSlider für alle Container
  // Speichere die Instanz in einem Data-Attribut, um mehrfache Initialisierungen zu vermeiden (z.B. bei gecachten Seiten)
  jQuery('.mad-slider__container--hover-video').each(function() {
    const $container = jQuery(this);
    if (!$container.data('hoverVideoSliderInst')) {
      $container.data('hoverVideoSliderInst', new HoverVideoSlider(this));
    }
  });
});

/*
// Prevent <a> Link from reloading the Page and scroll to the target
jQuery(document).on('click', '.mad-hover-video__link', function(e) {
  const href = jQuery(this).attr('href');
  if (href.indexOf('#') !== -1) {
    const hash = href.slice(href.indexOf('#'));
    const $target = jQuery(hash);
    if ($target.length) {
      e.preventDefault();
      jQuery('html, body').animate({ scrollTop: $target.offset().top }, 600);
    }
  }
});*/
